<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newBookEntryDeferredBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea una
                  nuova Polizza cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewBookEntryDeferred"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button
                >
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
          <template #cell(last_deferred)="{ item }" v-if="items.length">
            {{
              checkLastDeferredDate(item.entry_details)
                ? moment(checkLastDeferredDate(item.entry_details)).format(
                  "DD/MM/YYYY"
                )
                : "-"
            }}
          </template>
          <template #cell(branch)="{ item }" v-if="items.length">
            {{
              item.insurance_ancillaries && item.insurance_ancillaries.length
                ? item.insurance_ancillaries[0].insurance_policy
                  ? item.insurance_ancillaries[0].insurance_policy
                    .insurance_risk
                    ? item.insurance_ancillaries[0].insurance_policy
                      .insurance_risk.risk_branch?.formatted_title
                    : ""
                  : ""
                : item.various_accountings && item.various_accountings.length
                  ? item.various_accountings[0].pivot.insurance_risk
                    ? item.various_accountings[0].pivot.insurance_risk.risk_branch
                      ?.formatted_title
                    : ""
                  : ""
            }}
          </template>
          <template #cell(product)="{ item }" v-if="items.length">
            <span>{{
              item.insurance_ancillaries && item.insurance_ancillaries.length
                ? item.insurance_ancillaries[0].insurance_policy
                  ? item.insurance_ancillaries[0].insurance_policy
                    ?.insurance_risk?.formatted_title
                  : ""
                : item.various_accountings && item.various_accountings.length
                  ? item.various_accountings[0].pivot.insurance_risk
                    ? item.various_accountings[0].pivot.insurance_risk
                      ?.formatted_title
                    : ""
                  : ""
            }}</span>
          </template>
          <template
            #cell(insurance_policy_number)="{ item }"
            v-if="items.length"
          >
            {{
              item.various_accountings && item.various_accountings.length
                ? item.various_accountings[0].pivot.insurance_policy_number
                : item.insurance_ancillaries &&
                item.insurance_ancillaries.length
                  ? item.insurance_ancillaries[0].insurance_policy
                    ? item.insurance_ancillaries[0].insurance_policy.number
                    : ""
                  : ""
            }}
          </template>
          <template #cell(note_counter)="row" v-if="items.length">
            <div
              role="button"
              class="info-box float-left"
              @click="customOpenNoteModal(row.item, row.index, $event.target)"
              v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 2 && task.context === 'deferred'),
                  'Note',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Creato da',
                      key: 'owner_id',
                      formatter: (val) => retriveOwner(val),
                    },
                    {
                      label: 'Data creazione',
                      key: 'created_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
            >
              {{
                row.item.tasks.filter((task) => task.task_type.value === 2 && task.context === 'deferred')
                  .length
              }}
            </div>
          </template>
          <template #cell(registry)="{ item }" v-if="items.length">
            <template v-if="item.registries.length">
              <div v-for="(registry, index) in item.registries" :key="index">
                <span
                  v-if="
                    !Array.isArray(registry.attributables) &&
                    !registry.attributables.length
                  "
                >{{
                    registry.status_registry.value === 1
                      ? registry.attributables.CNAM
                      : registry.attributables.SURN +
                      " " +
                      registry.attributables.NAME
                  }}</span
                >
              </div>
            </template>
            <template v-else-if="item.various_accountings.length">
              <template
                v-if="
                  item.various_accountings[0] != null &&
                  Object.prototype.hasOwnProperty.call(
                    item.various_accountings[0],
                    'pivot'
                  ) &&
                  item.various_accountings[0].pivot != null &&
                  Object.prototype.hasOwnProperty.call(
                    item.various_accountings[0].pivot,
                    'registry_title'
                  )
                "
              >
                <span data-fallback="true">{{
                    item.various_accountings[0].pivot.registry_title
                  }}</span>
              </template>
            </template>
          </template>
          <template #cell(primary_group)="{ item }" v-if="items.length">
            <div v-for="(registry, index) in item.registries" :key="index">
              <span v-if="registry.registry_groups.length">{{
                  registry
                    ? registry.registry_groups.length && registry.registry_groups.find(
                      registry_group => registry_group.pivot.primary.value === 'Y'
                    ) ? registry.registry_groups.find(
                      registry_group => registry_group.pivot.primary.value === 'Y'
                    ).code : "-"
                    : "-",
                }}</span>
              <span v-else>-</span>
            </div>
          </template>
          <template #cell(deferred)="{ item }" v-if="items.length">
            {{ toLocaleCurrency(totalDeferred(item)) }}
          </template>
          <template #cell(broker)="{ item }" v-if="items.length">
            <span v-html="toInfoData(item.brokers[0], 'broker', 0)"></span>
          </template>
          <template #cell(note)="{ item }" v-if="items.length">
            {{ item.tasks.length }}
          </template>
          <template #cell(check)="row" v-if="hasChecks">
            <base-checkbox
              name="check"
              v-model="row.item.check"
              @input="onSelectRow($event, row.index, row.item)"
            />
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="$store.state.auth.settings.attributables.LISAPAY === 'Y'"
                style="background-color: white; border-radius: 5px; border: 1px solid #23469d;; height: 25px; width: 24px; margin-top: 2px"
                size="sm"
                title="Recupera con Lisapay"
                @click="
                  customOpenLisapayModal(row.item, row.index, $event.target)
                "
                :disabled="recoveryStatus(row.item).value === 2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 45 45"
                >
                  <path
                    d="M22.5.5c-12.14 0-22 9.86-22 22s9.86 22 22 22 22-9.86 22-22-9.844-22-22-22zm8.737 34.47H16.058c-2.015 0-3.667-1.635-3.667-3.65h0V12.095a3.67 3.67 0 0 1 3.667-3.667c2.015 0 3.667 1.635 3.667 3.65h0v15.559h11.512c2.015 0 3.667 1.635 3.667 3.65v.017a3.67 3.67 0 0 1-3.667 3.667h0z"
                    fill="#23469d"
                  />
                </svg>
                <span class="sr-only">Recupera con Lisapay</span></b-button
              >
              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>
            </div>
          </template>
          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell(recovery_status)="{ item }">
            <status-badge kind="recovery" :status="recoveryStatus(item)" />
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <table-totals :items="totals" />
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="custoModalTitle"
        :size="custoModalSize"
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14"/>
        </template>
        <div>
          <b-tabs
            :nav-class="`${
              $store.state.auth.settings.attributables.LISAPAY === 'Y'
                ? 'modal-tab-lisapay--visible'
                : 'modal-tab-lisapay--hidden'
            }`"
            content-class="pt-1"
            lazy
            v-model="tabIndex"
          >
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              :title-item-class="['lisaweb', tab.itemClass]"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import StatusBadge from "@/components/StatusBadge";
import BaseIcon from "@/components/BaseIcon";
import TableTotals from "@/components/TableTotals";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import General from "@/components/accounting/deferred/details/General.vue";
import Deferred from "@/components/accounting/deferred/details/Deferred.vue";
import Appointments from "@/components/accounting/deferred/details/Appointments";
import Notes from "@/components/accounting/deferred/details/Notes";
import Todo from "@/components/accounting/deferred/details/Todo";
import CollectLisapay from "@/components/accounting/deferred/details/CollectLisapay";
import {toLocaleCurrency} from "@/utils/strings";
import {mapGetters} from "vuex";
import moment from "moment";
import EmptyTable from "@/components/EmptyTable.vue";

moment.locale("it");

export default {
  name: "BookEntriesDeferredTable",
  extends: template,
  data() {
    return {
      customModalClass: "modal-sospesi",
      custoModalTitle: "Dettagli",
      custoModalSize: "xl",
      modalTitleDefault: "Dettagli",
      modalTitleGroup: "Recupera sospeso con Lisapay",
      modalSizeGroup: "md",
      modalSizeDefault: "xl",
      tabs: [
        {name: "General", text: "Recupero Sospeso"},
        {name: "Deferred", text: "Storico Recupero"},
        {name: "Appointments", text: "Appuntamenti"},
        {name: "Notes", text: "Note"},
        {name: "Todo", text: "Attività"},
        {
          name: "CollectLisapay",
          text: "Recupera con Lisapay",
          itemClass: "lisapay-collect",
        },
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
      dbRowData: null,
    };
  },
  components: {
    StatusBadge,
    BaseIcon,
    TableTotals,
    General,
    Deferred,
    ButtonGroupTab,
    BaseCheckbox,
    Todo,
    Notes,
    Appointments,
    BaseInputPagination,
    EmptyTable,
    CollectLisapay,
  },
  props: {
    total_deferred: {
      type: Object,
      default() {
        return {};
      },
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newBookEntryDeferredBtn: {
      type: Boolean,
      default: false,
    },
    total_collected: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    moment,
    toLocaleCurrency,
    customOpenLisapayModal(item, index, target) {
      this.tabIndex = 5; // TabIndex ID di CollectLisapay
      this.custoModalTitle = this.modalTitleGroup;
      this.custoModalSize = this.modalSizeGroup;
      this.customModalClass += " collect-lisapay-tab-open";
      this.openModal(item, index, target);
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({name: "General", text: "Generale"}, 0);
      this.customModalClass = "modal-sospesi";
      this.custoModalTitle = this.modalTitleDefault;
      this.custoModalSize = this.modalSizeDefault;
    },
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 3; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewBookEntryDeferred() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    buildDeferredFilterQueryString() {
      const qsParts = [];
      const filterOn = this.prepareFilterQueryString(this.filterOn);
      if (filterOn) qsParts.push(filterOn);
      let filter = this.loadFilter(this.filterName);
      if (filter) {
        filter = this.processQueryString(filter, "deferred");
        qsParts.push(filter);
      }
      const sort = this.loadSort(this.filterName);
      if (sort) qsParts.push(sort);

      return qsParts.join("&");
    },
    getSelectedRowsLength() {
      if (this.selectedRows.length) {
        return this.selectedRows.length;
      }
      return 0;
    },
    totalDeferred(item) {
      return parseFloat(
        item.entry_details
          .filter((el) => el?.treasury?.code == "SS")
          .reduce(function (acc, obj) {
            return acc + obj.gross;
          }, 0)
          .toFixed(2)
      );
    },
    totalCollected(item) {
      return parseFloat(
        item.entry_details
          .filter((el) => el?.treasury?.code == "SS" && el.gross < 0)
          .reduce(function (acc, obj) {
            return acc + Math.abs(obj.gross);
          }, 0)
          .toFixed(2),
      );
    },
    checkLastDeferredDate(entry_details) {
      let filteredEntryDetails = entry_details.filter(
        (entry_detail) =>
          entry_detail?.treasury?.code === "SS" && entry_detail.gross < 0
      );
      if (filteredEntryDetails.length) {
        let lastDeferredDate = "1900-01-01";
        for (const entry_detail of filteredEntryDetails) {
          if (moment(entry_detail.detail_date).isAfter(lastDeferredDate)) {
            lastDeferredDate = entry_detail.detail_date;
          }
        }
        return lastDeferredDate;
      }
      return "";
    },
    customized(item) {
      let c = {};
      c.titolo = item.title;
      c.data_movimento = item.book_date;
      c.lordo = toLocaleCurrency(this.totalDeferred(item));
      return c;
    },
    // Stato di recupero: chiuso se non resta nulla da incassare, parziale se
    // c'è già un recupero, altrimenti aperto (toni in utils/statusBadge.js).
    recoveryStatus(item) {
      let value = 0;
      if (item) {
        if (this.totalDeferred(item) === 0) value = 2;
        else if (
          item.entry_details.find(
            (entry_detail) =>
              entry_detail?.treasury?.code === "SS" && entry_detail.gross < 0
          )
        )
          value = 1;
      }
      return {
        value,
        text: ["Aperto", "Parziale", "Chiuso"][value],
        title: value === 1 ? "Parzialmente recuperato" : null,
      };
    },
    retriveOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    }, ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
  computed: {
    // Totali fuori dalla tabella (TableTotals), nella riga della paginazione,
    // preceduti da da incassare · incassato delle righe selezionate, se ce
    // ne sono.
    totals() {
      if (!this.items.length) return [];
      const selected = this.getSelectedRowsLength();
      return [
        ...(selected
          ? [
              {
                label: `${selected} ${selected === 1 ? "selezionata" : "selezionate"}`,
                value: `${this.toLocaleCurrency(
                  this.grandTotalDeferred,
                )} · ${this.toLocaleCurrency(this.grandTotalCollected)}`,
                selection: true,
              },
            ]
          : []),
        ...[
          ["Totale da incassare", this.total_deferred],
          ["Totale incassato", this.total_collected],
        ]
          .filter(([, t]) => Object.keys(t).length)
          .map(([label, t]) => ({
            label,
            value: `${t.total ?? "-"} €`,
            loading: t.isLoading,
          })),
      ];
    },
    grandTotalDeferred() {
      // per ogni Righe Selezionate, calcolo totalDeferred e sommo
      let ret = 0;
      if (this.selectedRows.length) {
        ret = this.items
          .filter((e) => this.selectedRows.includes(e.id))
          .reduce(
            (previousValue, currentValue) =>
              previousValue + this.totalDeferred(currentValue),
            ret
          );
      }
      return ret;
    },
    grandTotalCollected() {
      let ret = 0;
      if (this.selectedRows.length) {
        ret = this.items
          .filter((e) => this.selectedRows.includes(e.id))
          .reduce(
            (previousValue, currentValue) =>
              previousValue + this.totalCollected(currentValue),
            ret,
          );
      }
      return ret;
    },
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/table-mixins";
@include table-check-column;

.label {
  margin-left: 5px;
  margin-right: 5px;
  padding: 0;
  margin-top: 8px;
  font-size: var(--font-size-sm);
}

.info {
  text-align: right;
}

@include accounting-table-totals;
</style>
